import { OpportunityKind } from 'anchor-scout-common/types';
const KIND_TEXT_KEY = {
    [OpportunityKind.StalePrice]: 'stalePrice',
    [OpportunityKind.DiscountLeak]: 'discountLeak',
    [OpportunityKind.RecurringAdhoc]: 'recurringAdhoc',
    [OpportunityKind.CrossSell]: 'crossSell'
};
export const kindText = (kind, texts)=>texts[KIND_TEXT_KEY[kind]]();
export const confidenceLabel = (band, texts)=>{
    switch(band){
        case 'high':
            return texts.high();
        case 'medium':
            return texts.medium();
        case 'low':
            return texts.low();
    }
};
